import React from 'react';

import {runURL} from 'results/assays/AssayRecordDAO';
import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import {apiIdToIconName} from 'util/APIUtil';
import {readableTime} from 'util/DateUtil';

import SmartChip from './SmartChip';
import useSmartChipQuery, {SmartChipType} from './useSmartChipQuery';

export default function RunChip(props: SharedSmartChipProps<SmartChipType.RUN>): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: run,
    handleClickLink,
    isInaccessible,
    itemUrl: runUrl,
  } = useSmartChipQuery<SmartChipType.RUN>({
    id,
    onClick,
    getUrlFn: (run) => runURL(run.apiId),
  });

  let chipRun;
  if (run != null) {
    const date = readableTime(run.createdAt);
    chipRun = {
      ...run,
      id: run.apiId,
      name: `${run.schema.name} ${date}`,
    };
  }

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={run != null ? apiIdToIconName(run.apiId) : null}
      isInaccessible={isInaccessible}
      item={chipRun}
      onClick={handleClickLink}
      url={runUrl}
    />
  );
}
